// extracted by mini-css-extract-plugin
module.exports = {"content":"sub_header_content-module__content--27jx7"};